import { useRef } from 'react'

import { type UserMeExEntity } from '@/libs/api'

/**
 * ログインユーザーが変更された場合の判定用フック
 * - 指定したログインユーザーIDが前回と異なる場合はリロードする
 * - ログインユーザー取得の useQuery は refetchOnWindowFocus が true になってる前提
 */
export const useReloadIfAuthUserChanged = (
  currentUser: UserMeExEntity | null
) => {
  const previousUser = useRef(currentUser)

  if (previousUser.current && previousUser.current.id !== currentUser?.id) {
    location.reload()
  }
}
